import { getDoc } from 'firebase/firestore'
import { PullService } from './servicePull'
import type { WciaSchema } from '~/models/WciaSchema'

export class WciaServicePull extends PullService<WciaSchema, WciaSchema[]> {
  private readonly doc

  constructor() {
    super()
    const { doc } = useFirebase()
    this.doc = doc
  }

  public async getWciaSchema(wciaCode: string): Promise<WciaSchema | null> {
    const snapshot = await getDoc(
      this.doc<WciaSchema>('AppFormOptions/WciaOptions/WciaSchema', wciaCode),
    )

    return snapshot.data() ?? null
  }

  public async getUsagePerDay(wciaCode: string): Promise<number> {
    const snapshot = await getDoc(
      this.doc<WciaSchema>('AppFormOptions/WciaOptions/WciaSchema', wciaCode),
    )

    const data = snapshot.data()

    return data?.DosagePerDay ?? 0
  }
}
